export default {
  ai_explanation: {
    title: "How Estimator24 Works",
    intro:
      "Estimator24 uses artificial intelligence and data analysis to determine the fair market value of real estate based on dozens of factors.",
    how_it_works: {
      title: "How the Price is Calculated",
      step1: "The system finds similar properties within a 20 km radius.",
      step2: "It analyzes features such as area, floor, year built, view, and infrastructure.",
      step3: "Several machine learning models make independent price predictions.",
      step4: "The final price is a weighted average adjusted for market trends."
    },
    models: {
      title: "Estimator24 Models",
      xgboost: "A comprehensive model analyzing all available property features.",
      lightgbm: "Compares the property with nearby similar listings.",
      randomforest: "Detects rare feature combinations and undervalued properties.",
      neural: "A neural network trained on historical data and property photos.",
      regression: "A statistical model that reflects overall market dynamics."
    },
    market: {
      title: "What 'Below' or 'Above Market' Means",
      desc: "If a property’s price is below the district average — it may be a good deal. If it’s above — it could reflect a better condition, view, or location. Estimator24 compares all factors to show the true market position."
    }
  }
}
